import { initializeApp, getApps } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LczJ-osAAAAAEGWpaaYFmRTkVUL-Pf7le-fXFTv'),
  isTokenAutoRefreshEnabled: true,
});

export const auth = getAuth(app);

// The live Firestore database: `mobilistan`, in Doha (me-central1). Images: REACT_APP_FIREBASE_STORAGE_BUCKET
// (al-sami-electronics-doha). See docs/DOHA-MOVE-PLAN.md.
export const FIRESTORE_DATABASE = process.env.REACT_APP_FIRESTORE_DATABASE || 'mobilistan';

export const firestore = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
}, FIRESTORE_DATABASE);

// Local test backend (Firebase emulators) for the owner's test before a push — `npm start` with
// REACT_APP_LOCAL_BACKEND=1 only. A production build (npm run build) has NODE_ENV 'production', so the live admin
// panel can never be pointed away from the real server.
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_LOCAL_BACKEND === '1') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
  connectFunctionsEmulator(getFunctions(app, 'me-central1'), '127.0.0.1', 5001);
  // eslint-disable-next-line no-console
  console.warn('[firebase] LOCAL TEST BACKEND (emulators) — not the live server');
}

// Secondary app used only for creating employee auth accounts without
// signing out the currently logged-in admin session
const secondaryApp =
  getApps().find(a => a.name === 'secondary') ||
  initializeApp(firebaseConfig, 'secondary');
export const secondaryAuth = getAuth(secondaryApp);

export default app;
